// Limits collisions with poor actors.
const prefix = "page-builder-"

export const devToken = `${prefix}devToken`
export const whatsNewDialog = `${prefix}whatsNewDialog`
export const sliceTableCopiedSlice = `${prefix}sliceTableCopiedSlice`
export const lab = `${prefix}lab`
